import MixByType from './MixByType.js';
import {
    LINEAR 
} from './constants.js';

class LinearMixByType extends MixByType {
    constructor(type, sequencerEngine, subSequence) {
        super(type);

        this.sequencerEngine = sequencerEngine;
        this.subSequence = subSequence;
    }

    getMixType() {
        return LINEAR;
    }

    getValueAtStep(step, value=1) {
        let nextEvent = this.getNextEvent({step}, true);
        let previousEvent = this.getPreviousEvent({step}, false, true);

        if (previousEvent === undefined) {
            if (nextEvent === undefined) {
                return value;
            }

            let ratio = step / nextEvent.step;
            return value * (1 - ratio) + nextEvent.value * ratio;
        }

        if (nextEvent === undefined) {
            // last event
            return previousEvent.volume;
        }

        let ratio = (step - previousEvent.step) /
            (nextEvent.step - previousEvent.step);

        return previousEvent.volume*(1 - ratio) + nextEvent.volume*ratio;
    }

    deleteEvent(event) {
        let i = this.events.indexOf(event);
        if (i > -1) {
            this.events.splice(i, 1);
        }

        this.updateRedux(this.subSequence, this.sequencerEngine);
    }

    loadFromJson(json, sequencerEngine, subSequence) {
        super.loadFromJson(json, sequencerEngine, subSequence);

        this.updateRedux(subSequence, sequencerEngine);
    }
}

export default LinearMixByType;
